import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    block: { padding: '46px' },
    title: { display: 'flex', alignItems: 'center', marginBottom: '40px' },
    backButton: { cursor: 'pointer', marginRight: '16px' },
    titleText: { fontSize: '28px', fontWeight: 'bold' },
    buttons: {
      display: 'flex',
      marginBottom: '46px',
      justifyContent: 'center',
    },
    codesTitle: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' },
    button: {
      padding: '8px 20px',
      backgroundColor: '#fff',
    },
    filledButton: {
      backgroundColor: accentColor,
      color: theme.colors.white,
    },
    tipsBlock: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' },
    tipBlock: { display: 'flex', marginBottom: '20px' },
    tipNumber: { fontSize: '32px', marginRight: '10px' },
    tipInfo: { display: 'flex', flexDirection: 'column' },
    tipMessage: { fontSize: '16px', marginBottom: '20px', minHeight: '120px' },
    tipImage: { width: '400px' },
  }
}
